import AccountAdd from '@/pages/administration/AccountAdd.vue'
import AccountDetail from '@/pages/administration/AccountsListDetailPage.vue'
import AccountEdit from '@/pages/administration/AccountEdit.vue'
import Accounts from '@/pages/administration/AccountsPage.vue'
import ListCompanies from '@/pages/administration/CompaniesList.vue'
import ListUsers from '@/pages/administration/UsersList.vue'
import History from '@/pages/administration/HistoryPage.vue'
import Company from '@/pages/administration/CompanyPage.vue'
import DetailCompany from '@/pages/administration/DetailCompanyPage.vue'
import AddCompany from '@/pages/administration/AddCompanyPage.vue'
import AddRights from '@/pages/administration/AddRights.vue'
import EditRights from '@/pages/administration/EditRights.vue'
import UserCompany from '@/pages/administration/UserCompanyPage.vue'
import DetailUserCompany from '@/pages/administration/DetailUserCompanyPage.vue'
import EditUserCompany from '@/pages/administration/EditUserCompanyPage.vue'
import AddUserCompany from '@/pages/administration/AddUserCompanyPage.vue'
import EditCompany from '@/pages/administration/EditCompanyPage.vue'
import DetailProfilCompany from '@/pages/administration/DetailProfilCompanyPage.vue'
import EditProfilCompany from '@/pages/administration/EditProfilCompanyPage.vue'
import AddProfilCompany from '@/pages/administration/AddProfilCompanyPage.vue'
import TransactionHistoryList from '@/pages/administration/TransactionHistoryListPage.vue'
import DetailTransactionHistoryList from '@/pages/administration/DetailTransactionHistoryListPage.vue'
import TransactionStatHistory from '@/pages/administration/TransactionStatHistoryPage.vue'
import OCRTemplateListPage from '@/pages/administration/OCRTemplateListPage.vue'
import AddOCRTemplatePage from '@/pages/administration/AddOCRTemplatePage.vue'
import RTPSettings from '@/pages/administration/RTPSettings.vue'

export default [
  {
    path: '/administration/accountAdd/:type',
    component: AccountAdd
  },
  {
    path: '/administration/accountDetail/:idUserAccount',
    component: AccountDetail
  },
  {
    path: '/administration/accountEdit/:idUserAccount',
    component: AccountEdit
  },
  {
    path: '/administration/accounts/',
    component: Accounts
  },
  {
    path: '/administration/listCompanies/',
    component: ListCompanies
  },
  {
    path: '/administration/listUsers/',
    component: ListUsers
  },
  {
    path: '/history/',
    component: History
  },
  {
    path: '/company/',
    component: Company
  },
  {
    path: '/detail/:idCompany',
    component: DetailCompany
  },
  {
    path: '/addcompany/',
    component: AddCompany
  },
  {
    path: '/addrights/:idCompany',
    component: AddRights
  },
  {
    path: '/editrights/',
    component: EditRights
  },
  {
    path: '/usercompany/',
    component: UserCompany
  },
  {
    path: '/detailusercompany/:idUserAcc/:idCompany',
    component: DetailUserCompany
  },
  {
    path: '/editusercompany/:idUserAcc/:idCompany',
    component: EditUserCompany
  },
  {
    path: '/addusercompany/:idCompany',
    component: AddUserCompany
  },
  {
    path: '/editcompany/:idCompany',
    component: EditCompany
  },
  {
    path: '/detailprofilcompany/:id_rights_profile/:idCompany',
    component: DetailProfilCompany
  },
  {
    path: '/editprofilcompany/:id_rights_profile/:idCompany',
    component: EditProfilCompany
  },
  {
    path: '/addprofilcompany/:idCompany',
    component: AddProfilCompany
  },
  {
    path: '/transactionhistorylist/',
    component: TransactionHistoryList
  },
  {
    path: '/detailtransactionhistorylist/:id',
    component: DetailTransactionHistoryList
  },
  {
    path: '/transactionstathistory/',
    component: TransactionStatHistory
  },
  {
    path: '/ocrtemplatelist/',
    component: OCRTemplateListPage
  },
  {
    path: '/ocrtemplate_add/',
    component: AddOCRTemplatePage
  },
  {
    path: '/settings/rtpSettings/',
    component: RTPSettings
  },
]
